export const intervalUnits = {
    hours: "Hours",
    days: "Days",
};
